<template>
	<!-- 临时文件，后期与PartUpload合并 -->
	<div class="upload-wrap">
		<div v-show="false">文件上传： <input type="file" name="file" id="fileId" ref="inputFile" @change="handleChange" multiple /></div>
		<div style="position: relative">
			<div @click="handleClick" class="upload-content" ref="uploadContent">
				<slot>
					<el-button size="mini" class="dark-btn">上传</el-button>
				</slot>
			</div>
			<!-- <div class="upload-info-list2" v-viewer> -->
			<div class="upload-info-list2">
				<!-- 原有的图片 -->
				<div class="file-info2" v-for="(basic, index) in basicIdsTemp" :key="index">
					<div class="img-wrap url">
						<img :src="basicUrls[index]" @click="imgClick(index, basicUrls)" />
					</div>
					<div class="info" :title="basicUrls[index]">
						<span class="info-name">{{ basicUrls[index] }}</span>
						<span class="info-size">{{ "" }}</span>
					</div>
					<div class="close" @click="handleRemoveBasic(index)">
						<i class="el-icon-close"></i>
					</div>
				</div>
				<!-- 新上传的图片 -->
				<div class="file-info2" v-for="({ file }, key) in checkpoints" :key="key">
					<div class="img-wrap">
						<img :src="getUrl(file)" />
					</div>
					<div class="info" :title="file && file.name">
						<span class="info-name">{{ file && file.name }}</span>
						<span class="info-size">{{ file && file.size | fileSizeFormat }}</span>
					</div>
					<div class="close" @click="handleRemove(key)">
						<i class="el-icon-close"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import OSS from "ali-oss";
import { getSuffix, getObjectURL } from "@/utils/utils";
import { CommonService, OpenService } from "@/service";

export default {
	components: {
		// Progress,
	},
	props: {
		// 默认的ids
		basicIds: {
			default() {
				return [];
			},
		},
		// 默认的url
		basicUrls: {
			default() {
				return [];
			},
		},
		// 是否禁用
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		basicIds: {
			immediate: true,
			handler(newValue, oldValue) {
				this.basicIdsTemp = [...(newValue || [])];
				this.checkpoints = {};
				this.clients = {};
			},
		},
	},
	data() {
		return {
			basicIdsTemp: [],
			fileList: [],
			loading: null,
			partSize: 1024 * 1024 * 5, // 分片大小
			parallel: 5, // 同时上传分片数
			checkpoints: {}, // 所有文件上传的检查点
			clients: {}, // oss 实例集合
			configOss: {
				//  阿里云主账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM账号进行API访问或日常运维，请登录RAM控制台创建RAM账号。
				accessKeyId: "<Your AccessKeyId>",
				accessKeySecret: "<Your AccessKeySecret>",
				region: "<Your region>", // bucket 所在的区域，默认 oss-cn-hangzhou。
				bucket: "Your bucket name", // 通过控制台创建的bucket。
				stsToken: "", // 进行临时授权访问凭证
				secure: true, // (secure: true) 则使用 HTTPS， (secure: false) 则使用 HTTP
			},
		};
	},
	created() {},
	methods: {
		imgClick(index, arr) {
			OpenService.openImgPreview(index, arr);
		},
		localImgClick(key, checkpoints) {
			let index = Object.keys(checkpoints).indexOf(key);
			let urls = Object.values(checkpoints).map((item) => getObjectURL(item.file));
			console.log("	localImgClick", index, urls);
			OpenService.openImgPreview(index, urls);
		},
		handleRemoveBasic(index) {
			this.basicIdsTemp.splice(index, 0);
			this.uploadSuccess();
		},
		handleRemove(key) {
			this.$delete(this.checkpoints, key);
			this.$delete(this.clients, key);
			this.uploadSuccess();
		},
		uploadSuccess() {
			this.$emit("uploadSuccess", this.basicIdsTemp.concat(Object.values(this.checkpoints).map((item) => item.uploadId)));
		},
		getUrl(file) {
			return getObjectURL(file);
		},
		// 创建oss实例
		createOSS() {
			return new OSS(this.configOss);
		},
		// 选择文件
		handleClick() {
			if (!this.disabled && !this.loading?.visible) {
				this.$refs.inputFile.value = null;
				this.$refs.inputFile.click();
			}
		},
		// 文件变化
		handleChange(ev) {
			const files = ev.target.files;
			if (!files) return;
			this.getFilesOSSConfig(files);
		},
		getFilesOSSConfig(files) {
			let params = [];
			files.forEach(({ name, type, size }) => params.push({ name, type, size }));
			CommonService.authUploadFiles({ files: params }).then((res) => {
				console.log("ossConfig:", res.data);
				let data = res.data || {};
				let { SecurityToken: stsToken, AccessKeyId: accessKeyId, AccessKeySecret: accessKeySecret } = data.credentials;

				this.configOss = {
					region: "oss-cn-hangzhou",
					bucket: "gbwlm",
					accessKeyId,
					accessKeySecret,
					stsToken,
				};

				this.handleUpload(files, data.uploadFileNameList, data.idList);
			});
		},
		handleUpload(files, uploadFileNameList, idList) {
			let promiseArr = [];
			files.forEach((file, index) => {
				let key = new Date().getTime();
				// 初始化 进度信息
				this.$set(this.checkpoints, key, { p: 0, file, uploadId: idList[index], uploadFileName: uploadFileNameList[index] });
				let oss = this.createOSS();
				this.$set(this.clients, key, oss);
				let promise = new Promise((resolve, reject) => {
					// 普通上传
					this.clients[key]
						.put(uploadFileNameList[index], file, {
							// partSize: this.partSize,
							// progress: (p, checkpoint) => {},
						})
						.then((res) => {
							this.checkpoints[key] = { ...this.checkpoints[key], p: 100 };

							let obj = {
								...file,
								...res,
							};
							console.log("上传完成：", obj);
							resolve(obj);
						})
						.catch((e) => {
							reject(e);
						});
				});
				promiseArr.push(promise);
			});

			Promise.all(promiseArr)
				.then((res) => {
					this.uploadSuccess();
				})
				.catch((e) => {
					console.log("uploadFail	", e);
				})
				.finally((e) => {});
		},
	},
};
</script>

<style lang="less" scoped>
.upload-info-list2 {
	max-width: 560px;
	margin-top: 4px;
	border-radius: 4px;
	background-color: rgb(226 220 220 / 80%);
	z-index: 999;
}
.file-info2 {
	// width: 250px;
	display: flex;
	align-items: center;
	font-size: 12px;
	padding: 8px;
	border: 1px solid #dcdee3;
	background-color: #fff;
	margin-bottom: 4px;

	.img-wrap {
		&.url {
			cursor: pointer;
		}
		flex-shrink: 0;
		width: 48px;
		height: 48px;
		color: #e0e0e0;
		border: 1px solid #dcdee3;
		border-radius: 0;
		background-color: #f2f3f7;
		vertical-align: middle;
		text-align: center;
		overflow: hidden;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.info {
		flex: 1;
		display: flex;
		margin-left: 10px;
		width: 20%;
		.info-name {
			flex: 1;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
			width: 20%;
		}
		.info-size {
			flex-shrink: 0;
			color: #999;
			margin-left: 8px;
		}
	}
	.close {
		// width: 12px;
		// height: 12px;
		margin-left: 5px;
		color: #999;
		cursor: pointer;
		flex-shrink: 0;
		i {
			font-size: 14px;
		}
	}
}

.el-icon-upload-success {
	color: #67c23a;
}
.upload-wrap {
	position: relative;
	.upload-content {
		display: inline-block;
	}

	.upload-info-list {
		margin-top: 4px;
		border-radius: 4px;
		background-color: rgb(226 220 220 / 80%);
		// padding: 0px 5px 6px 5px;
		position: absolute;
		// left: 0px;
		// top: 0;
		width: 300px;
		z-index: 999;
		// margin: 0px 5px 0px 0;
		.file-info {
			// margin: 0 5px 6px;
			padding: 5px;
			.title {
				// margin-top: 7px;
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
		}
	}
	::v-deep ._upload_loading {
		.el-loading-spinner {
			margin-top: 0;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}
}
</style>
